import React from 'react'
import {RWebShare} from "react-web-share";
import tw from 'twin.macro'

const Div =tw.div`flex justify-end items-center px-5`

function SocialShareButton() {
  return (
    <Div>  <RWebShare
      data={{
     
        title: "FlexPosters",
      }}
      onClick={() => console.log("shared successfully!")}
    >
      <button>Share 🔗</button>
    </RWebShare></Div>
  )
}

export  {SocialShareButton}